(function() {
  'use strict';

  var dialog;
  var activeCartForm;
  var returnFocusToTerms = false;
  var isBound = false;

  function getDialog() {
    if (!dialog) {
      dialog = document.getElementById('CartTermsDialog');
    }

    return dialog;
  }

  function setOpenState(isOpen) {
    document.documentElement.classList.toggle('cart-terms-dialog-open', isOpen);
  }

  function closeDialog() {
    var element = getDialog();

    if (!element) {
      return;
    }

    if (typeof element.close === 'function' && element.open) {
      element.close();
    } else {
      element.removeAttribute('open');
      setOpenState(false);
    }
  }

  function focusTermsCheckbox() {
    if (!activeCartForm || !activeCartForm.termsCheckbox) {
      return;
    }

    activeCartForm.termsCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    activeCartForm.termsCheckbox.focus({ preventScroll: true });
  }

  function reviewTerms() {
    returnFocusToTerms = true;
    closeDialog();
  }

  function acceptTerms() {
    var cartForm = activeCartForm;

    if (!cartForm || !cartForm.termsCheckbox || !cartForm.submitBtn) {
      closeDialog();
      return;
    }

    returnFocusToTerms = false;
    cartForm.termsCheckbox.checked = true;
    cartForm.termsCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    closeDialog();

    window.setTimeout(function() {
      cartForm.submitBtn.click();
    }, 0);
  }

  function bindDialog() {
    var element = getDialog();

    if (!element || isBound) {
      return;
    }

    isBound = true;

    element.querySelector('[data-cart-terms-accept]').addEventListener('click', acceptTerms);
    element.querySelector('[data-cart-terms-review]').addEventListener('click', reviewTerms);
    element.querySelector('[data-cart-terms-close]').addEventListener('click', reviewTerms);

    element.addEventListener('cancel', function(event) {
      event.preventDefault();
      reviewTerms();
    });

    element.addEventListener('click', function(event) {
      if (event.target === element) {
        reviewTerms();
      }
    });

    element.addEventListener('close', function() {
      setOpenState(false);

      if (returnFocusToTerms) {
        window.setTimeout(focusTermsCheckbox, 0);
      }
    });
  }

  function open(cartForm) {
    var element = getDialog();

    activeCartForm = cartForm;
    returnFocusToTerms = false;

    if (!element) {
      focusTermsCheckbox();
      return;
    }

    bindDialog();
    setOpenState(true);

    if (typeof element.showModal === 'function') {
      if (!element.open) {
        element.showModal();
      }
    } else {
      element.setAttribute('open', '');
    }

    window.setTimeout(function() {
      var acceptButton = element.querySelector('[data-cart-terms-accept]');

      if (acceptButton) {
        acceptButton.focus();
      }
    }, 0);
  }

  window.WLCartTermsDialog = {
    open: open
  };
})();
